function toFraction(decimal) {
  const str = decimal.toString();
  const decimals = str.split(".")[1]?.length || 0;
  const denominator = 10 ** decimals;
  const numerator = Math.round(decimal * denominator);

  const gcd = (a, b) => (b === 0 ? a : gcd(b, a % b));

  const g = gcd(numerator, denominator);
  return [numerator / g, denominator / g];
}

export function findWholePrice(remainingAmount, percent = 3.5, divisible = 10) {
  const k = 1 - percent / 100;

  const [num, den] = toFraction(k); // k = num/den

  const t = Math.ceil(remainingAmount / (divisible * num));

  return divisible * t * den;
}
